import React from "react";
import CouncilRegulatorsBanner from "../components/common/Banners/CouncilRegulatorsBanner";
import AtoZFilters from "../sections/Councils/AtoZFilters";

const CouncilRagulators = () => {
  return (
    <>
      <div className="tp-container-small mx-auto w-full">
        <CouncilRegulatorsBanner
          headingClasses={"text-center text-offblack"}
          heading={"Navigating Your Local Trade Regulations and Guidelines"}
        />
      </div>
      <div className="tp-container-narrow mx-auto w-full">
        <AtoZFilters />
      </div>
    </>
  );
};

export default CouncilRagulators;
